import type { RoundState } from '@magic/slot';

export const waysRound: RoundState[] = [
    {
        index: 0,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'SC',
                    scatter: true,
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'SC',
                    scatter: true,
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H3',
                },
            ],
            [
                {
                    name: 'H1',
                },
                {
                    name: 'SC',
                    scatter: true,
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
            ],
        ],
        paddingPositions: [235, 72, 168, 224, 61],
        gameType: 'basegame',
        anticipation: [0, 0, 1, 2, 3],
    },
    {
        index: 1,
        type: 'setTotalWin',
        amount: 0,
    },
    {
        index: 2,
        type: 'freeSpinTrigger',
        totalFs: 10,
        positions: [
            {
                reel: 0,
                row: 2,
            },
            {
                reel: 1,
                row: 2,
            },
            {
                reel: 3,
                row: 1,
            },
        ],
    },
    {
        index: 3,
        type: 'updateFreeSpin',
        amount: 0,
        total: 10,
    },
    {
        index: 4,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'L1',
                },
            ],
            [
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H5',
                },
            ],
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
            ],
        ],
        paddingPositions: [74, 84, 92, 19, 119],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 5,
        type: 'winInfo',
        totalWin: 80,
        wins: [
            {
                symbol: 'L3',
                kind: 3,
                win: 80,
                positions: [
                    {
                        reel: 0,
                        row: 1,
                    },
                    {
                        reel: 1,
                        row: 2,
                    },
                    {
                        reel: 1,
                        row: 3,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                    {
                        reel: 2,
                        row: 3,
                    },
                ],
                meta: {
                    ways: 4,
                    globalMult: 1,
                    winWithoutMult: 80,
                    symbolMult: 0,
                },
            },
        ],
    },
    {
        index: 6,
        type: 'setWin',
        amount: 80,
        winLevel: 2,
    },
    {
        index: 7,
        type: 'setTotalWin',
        amount: 80,
    },
    {
        index: 8,
        type: 'updateFreeSpin',
        amount: 1,
        total: 10,
    },
    {
        index: 9,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L2',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 4,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 3,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 1,
                },
            ],
            [
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H4',
                },
            ],
            [
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
            ],
        ],
        paddingPositions: [38, 91, 18, 84, 160],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 10,
        type: 'setTotalWin',
        amount: 80,
    },
    {
        index: 11,
        type: 'updateFreeSpin',
        amount: 2,
        total: 10,
    },
    {
        index: 12,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L4',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'H1',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'SC',
                    scatter: true,
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'H4',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
            ],
        ],
        paddingPositions: [144, 54, 91, 92, 118],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 13,
        type: 'setTotalWin',
        amount: 80,
    },
    {
        index: 14,
        type: 'updateFreeSpin',
        amount: 3,
        total: 10,
    },
    {
        index: 15,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 2,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 3,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 4,
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'L1',
                },
            ],
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'H5',
                },
            ],
        ],
        paddingPositions: [176, 135, 124, 60, 80],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 16,
        type: 'setTotalWin',
        amount: 80,
    },
    {
        index: 17,
        type: 'updateFreeSpin',
        amount: 4,
        total: 10,
    },
    {
        index: 18,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'H4',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
            ],
            [
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'L1',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
            ],
        ],
        paddingPositions: [105, 109, 52, 89, 49],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 19,
        type: 'setTotalWin',
        amount: 80,
    },
    {
        index: 20,
        type: 'updateFreeSpin',
        amount: 5,
        total: 10,
    },
    {
        index: 21,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'H3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H4',
                },
            ],
            [
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 3,
                },
                {
                    name: 'WI',
                    wild: true,
                    multiplier: 4,
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
            ],
        ],
        paddingPositions: [162, 85, 179, 56, 120],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 22,
        type: 'setTotalWin',
        amount: 80,
    },
    {
        index: 23,
        type: 'updateFreeSpin',
        amount: 6,
        total: 10,
    },
    {
        index: 24,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L2',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H5',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
            ],
        ],
        paddingPositions: [38, 86, 160, 158, 20],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 25,
        type: 'setTotalWin',
        amount: 80,
    },
    {
        index: 26,
        type: 'updateFreeSpin',
        amount: 7,
        total: 10,
    },
    {
        index: 27,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L1',
                },
            ],
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H3',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
            ],
        ],
        paddingPositions: [121, 123, 7, 24, 97],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 28,
        type: 'winInfo',
        totalWin: 240,
        wins: [
            {
                symbol: 'L3',
                kind: 3,
                win: 240,
                positions: [
                    {
                        reel: 0,
                        row: 1,
                    },
                    {
                        reel: 0,
                        row: 2,
                    },
                    {
                        reel: 0,
                        row: 3,
                    },
                    {
                        reel: 1,
                        row: 2,
                    },
                    {
                        reel: 1,
                        row: 3,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                    {
                        reel: 2,
                        row: 3,
                    },
                ],
                meta: {
                    ways: 12,
                    globalMult: 1,
                    winWithoutMult: 240,
                    symbolMult: 0,
                },
            },
        ],
    },
    {
        index: 29,
        type: 'setWin',
        amount: 240,
        winLevel: 4,
    },
    {
        index: 30,
        type: 'setTotalWin',
        amount: 320,
    },
    {
        index: 31,
        type: 'updateFreeSpin',
        amount: 8,
        total: 10,
    },
    {
        index: 32,
        type: 'reveal',
        board: [
            [
                {
                    name: 'L1',
                },
                {
                    name: 'L1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'L3',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H1',
                },
                {
                    name: 'H3',
                },
            ],
            [
                {
                    name: 'L4',
                },
                {
                    name: 'L4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H2',
                },
                {
                    name: 'H2',
                },
            ],
        ],
        paddingPositions: [113, 75, 53, 116, 132],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 33,
        type: 'setTotalWin',
        amount: 320,
    },
    {
        index: 34,
        type: 'updateFreeSpin',
        amount: 9,
        total: 10,
    },
    {
        index: 35,
        type: 'reveal',
        board: [
            [
                {
                    name: 'H1',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L4',
                },
            ],
            [
                {
                    name: 'H4',
                },
                {
                    name: 'H4',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L1',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'L3',
                },
                {
                    name: 'H2',
                },
            ],
            [
                {
                    name: 'H3',
                },
                {
                    name: 'H3',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'L2',
                },
            ],
            [
                {
                    name: 'L2',
                },
                {
                    name: 'L2',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
                {
                    name: 'H5',
                },
            ],
        ],
        paddingPositions: [176, 154, 70, 132, 130],
        gameType: 'freegame',
        anticipation: [0, 0, 0, 0, 0],
    },
    {
        index: 36,
        type: 'winInfo',
        totalWin: 240,
        wins: [
            {
                symbol: 'L3',
                kind: 3,
                win: 240,
                positions: [
                    {
                        reel: 0,
                        row: 1,
                    },
                    {
                        reel: 0,
                        row: 2,
                    },
                    {
                        reel: 0,
                        row: 3,
                    },
                    {
                        reel: 1,
                        row: 2,
                    },
                    {
                        reel: 1,
                        row: 3,
                    },
                    {
                        reel: 2,
                        row: 2,
                    },
                    {
                        reel: 2,
                        row: 3,
                    },
                ],
                meta: {
                    ways: 12,
                    globalMult: 1,
                    winWithoutMult: 240,
                    symbolMult: 0,
                },
            },
        ],
    },
    {
        index: 37,
        type: 'setWin',
        amount: 240,
        winLevel: 4,
    },
    {
        index: 38,
        type: 'setTotalWin',
        amount: 560,
    },
    {
        index: 39,
        type: 'freeSpinEnd',
        amount: 560,
        winLevel: 3,
    },
    {
        index: 40,
        type: 'finalWin',
        amount: 560,
    },
];
